__turbopack_context__.v({
  "className": "_8922JW_className",
  "variable": "_8922JW_variable",
});
